/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { FileType, FocusArea, Industry, LLMMessageOriginator, LLMMessageType, OpenAIModels, PracticeAreaEnum, QPChatState } from "../enums";
export const QPChatSchema = z.object({
  accountId: z.string().uuid().nullish(),
  chatHistory: 
    z.array(
      z.object({
        compactedResults: z.string().nullish(),
        llmMessageType: z.nativeEnum(LLMMessageType).nullish(),
        message: 
          z.object({
            createdAt: z.string().datetime().nullish(),
            fileIds: z.array(z.string()).nullish(),
            id: z.string().uuid().nullish(),
            matchingCandidates: 
              z.array(
                z.object({
                  candidateId: z.string().uuid().nullish(),
                  matchExplanation: z.string().nullish(),
                })
              )
            .nullish(),
            messageOriginator: 
              z.nativeEnum(LLMMessageOriginator)
            .nullish(),
            text: z.string().nullish(),
          })
        .nullish(),
        reasoning: 
          z.object({
            llmId: z.string().nullish(),
            rawThinkingData: z.string().nullish(),
            summary: z.string().nullish(),
          })
        .nullish(),
        toolCall: 
          z.object({
            arguments: z.string().nullish(),
            toolCallId: z.string().nullish(),
            toolName: z.string().nullish(),
          })
        .nullish(),
        toolCallResult: 
          z.object({
            output: z.string().nullish(),
            toolCallId: z.string().nullish(),
          })
        .nullish(),
      })
    )
  .nullish(),
  chatState: z.nativeEnum(QPChatState).nullish(),
  createdAt: z.string().datetime().nullish(),
  deleted: z.boolean(),
  focusArea: z.nativeEnum(FocusArea).nullish(),
  id: z.string().uuid(),
  industry: z.nativeEnum(Industry).nullish(),
  model: z.nativeEnum(OpenAIModels).nullish(),
  name: z.string().nullish(),
  openAiFiles: 
    z.object({}).catchall(
      z.object({
        fileName: z.string().nullish(),
        fileType: z.nativeEnum(FileType).nullish(),
      })
    )
  .nullish(),
  practiceArea: z.nativeEnum(PracticeAreaEnum).nullish(),
  updatedAt: z.string().datetime().nullish(),
  userId: z.string().uuid().nullish(),
});

export type QPChat = z.infer<typeof QPChatSchema>;
